import React, { useState } from "react";
import PTGC_Volume_PLS_Price_Popup from "./PTGC_Volume_PLS_Price_Popup";

const IndexSections = () => {
  const [holderQuantitybyholderModalOpen, setHolderQuantitybyholderModalOpen] = useState(false);
  const openHolderQuantitybyholder = () => setHolderQuantitybyholderModalOpen(true);
  const closeHolderQuantitybyholderModal = () => setHolderQuantitybyholderModalOpen(false);
  return (
    <>
          <div className="goldenBox snX"  data-aos="fade-up"  data-aos-delay="500" data-aos-duration="1000">
              <div className="d-flex justify-content-between gap-1 align-items-start">
                <div>
                  <h2>PTGC Volume vs PLS Price</h2>
            <p>Compare PTGC volume spikes with PLS price movements for trend insights.</p>
                  <button onClick={openHolderQuantitybyholder}  className="mybtn underline text-white p-0"><span>View Now</span></button>
                </div>
              </div>
          </div>


      <PTGC_Volume_PLS_Price_Popup modalIsOpen={holderQuantitybyholderModalOpen} closeModal={closeHolderQuantitybyholderModal}
      />
    </>
  );
};

export default IndexSections;
